<script>
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";
import {numeric, required} from "vuelidate/lib/validators";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import {VMoney} from "v-money";
import {pagingModel} from "@/models/pagingModel";
import Treeselect from "@riophae/vue-treeselect";
import {menuModel} from "@/models/menuModel";
import vue2Dropzone from "vue2-dropzone";
//import CKEditor from "@ckeditor/ckeditor5-vue";
//import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {notifyModel} from "@/models/notifyModel";
import {contentModel} from "@/models/contentModel";
import axios from "axios";
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import {userModel} from "@/models/userModel";

// import CKEditor from "@ckeditor/ckeditor5-vue";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";


export default {
  computed: {
  },
  page: {
    title: "Cập nhật bài viết",
    meta: [{name: "description", content: appConfig.description}],
  },
  // eslint-disable-next-line vue/no-unused-components
  components: {Multiselect, Layout, PageHeader, DatePicker,Treeselect, vueDropzone: vue2Dropzone,
    'ckeditor-nuxt': () => {
      return import('@blowstack/ckeditor-nuxt')
    },
    //ckeditor: CKEditor.component

  },
  directives: {money: VMoney},
  data() {
    return {
      data: [],
      title: "Cập nhật bài viết",
      items: [
        {
          text: "CẬP NHẬT BÀI VIẾT",
          active: true,
        }
      ],
      currentPage: 1,
      pageOptions: [5, 10, 25, 50, 100],
      sortBy: "age",
      filter: null,
      sortDesc: false,
      isShow : false,
      filterOn: [],
      numberOfElement: 1,
      totalRows: 1,
      perPage : 10,
      stt: 1,
      submitted: false,
      model: menuModel.baseJson(),
      modelContent: contentModel.baseJson(),
      pagination: pagingModel.baseJson(),
      treeView: [],
      listParent: [],
      //editor: ClassicEditor,
      editorConfig: {
        toolbar: {
          items: [
            'heading', '|','style',
            'bold',
            'italic',
            'link',
            'bulletedList',
            'numberedList',
            '|',
            'outdent',
            'indent',
            '|',
            'imageUpload',
            'blockQuote',
            'insertTable',
            'mediaEmbed',
            'codeBlock',
            'alignment',
            'ckbox',
            'fontColor',
            'fontBackgroundColor',
            'fontFamily',
            'fontSize',
            'formatPainter',
            'highlight',
            'htmlEmbed',
            'tableOfContents',
            'undo',
            'redo'
          ],
          shouldNotGroupWhenFull: false
        },
        removePlugins: ['Title', 'ImageCaption'],
        simpleUpload: {
          uploadUrl: process.env.VUE_APP_API_URL + "filesminio/uploadCK",
          headers: {
            'Authorization': 'optional_token'
          },
        },

      },
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}filesminio/upload`,
        acceptedFiles: ".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.xls,.xlsx",
        thumbnailHeight: 100,
        thumbnailWidth: 300,
        maxFiles: 30,
        maxFilesize: 50,
        maxFileSizeInMB:50,
        headers: {"My-Awesome-Header": "header value"},
        addRemoveLinks: true
      },
      image: "",
      file: "",
      baiviet:null,
      listMenu : [],
      urlFile:`${process.env.VUE_APP_API_URL}filesminio/view`
    };
  },
  validations: {
    modelContent: {
      // name: {required},
      // noiDung: {required},
      menu:{required},
    },
  },
  created() {
    this.GetTreeList();
    this.handleUpdate()
  },
  methods: {
    onAccept(file) {
      this.image = file.name;
      this.file = file;
    },
    RemoveTree(node, instanceId) {
      let value = this.modelContent.menu?.find(x => x.id == node.id);
      if (value != null) {
        this.modelContent.menu= this.modelContent.menu.filter(x => x.id != value.id);
        // console.log("DELETE",  this.listMenu )
      }
    },
    AddTree(node, instanceId) {
      let index = this.modelContent.menu?.findIndex(x => x.id == node.id);
      if (index == -1 || index == undefined) {
        if (!this.modelContent.menu){
          this.modelContent.menu= [];
        }
      //  console.log("LOG ADD NODE : ", this.node)
        this.modelContent.menu.push(node);
        // console.log("ADD", this.listMenu)
      }
    },
    async fnGetList() {
         this.$refs.tblList?.refresh()
    },
    normalizer(node){
      if(node.children == null || node.children == 'null'){
        delete node.children;
      }
    },
    async GetTreeList(){
      await this.$store.dispatch("menuCongDanStore/getTreeListTBV").then((res) => {
        this.treeView = res.data;
    //    console.log("LOG TREE VIEW : " , this.treeView)
      })
    },
    async handleUpdate() {
      await this.$store.dispatch("contentStore/getById", {"_id" : this.$route.params.id}).then((res) => {
        if (res.code===0) {
          // console.log(res)
          this.modelContent = contentModel.fromJson(res.data);
          // console.log("LOG MENU : ", this.modelContent)
          // if(res.data.ngayKyShow!=null){
          //   this.modelContent.ngayKy=res.data.ngayKyShow
          // }
          // if(res.data.ngayKyShow==""){
          //   this.modelContent.ngayKy=null
          // }
          // else {
          //   this.modelContent.ngayKy=null
          // }
          this.showModal = true;
        } else {
          this.$store.dispatch("snackBarStore/addNotify", {
            message: res.message,
            code: res.code,
          });
        }
      });
    },

    async handleSubmit(e) {
      // console.log("LOG THONG TIN ", this.model)
      e.preventDefault();
      this.submitted = true;
      this.$v.$touch();
      // console.log("LOG INVALID 36165 : ", this.$v);
      if (this.$v.$invalid) {
        // console.log("LOG INVALID  : ")
        return;
      } else {
        // console.log("LOG ELSE  INVALID  : ")
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
        // if (this.modelContent.ngayKy != null) {
        //   const formattedDate = this.formatDate(this.modelContent.ngayKy);
        //   this.modelContent.ngayKy = formattedDate
        // } else {
        //   this.modelContent.ngayKy = null
        // }
        await this.$store.dispatch("contentStore/update", contentModel.toJson(this.modelContent)).then((res) => {
          if (res.code === 0) {
            this.GetTreeList();
            this.showModal = false;
            this.modelContent = contentModel.baseJson();
            this.modelContent.noiDung='';
            this.$router.push('/danh-sach')
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
        });
        loader.hide();
        this.submitted = false;

        this.submitted = false;
      }
    },
    uploadFile(files,response) {
      let fileSuccess = response.data;
      // console.log('log suscess', response.data)
      if (response.code == 0){
        this.modelContent.files.push({
          fileId: fileSuccess.fileId,
          fileName: fileSuccess.fileName,
          ext: fileSuccess.ext,
          path: fileSuccess.path
        });
      }
      // console.log('log model file', this.modelContent.files)

    },

    removeThisFile(files, error, xhr) {
      let fileCongViec = JSON.parse(files.xhr.response);
      if (fileCongViec.data && fileCongViec.data.fileId) {
        let idFile = fileCongViec.data.fileId;
        let resultData = this.modelContent.files.filter(x => {
          return x.fileId != idFile;
        })
        this.modelContent.files = resultData;
        // console.log('log model file remove', this.modelContent.files)
      }

      // let fileCongViec = JSON.parse(files.xhr.response);
      // if (fileCongViec.data && fileCongViec.data.fileId) {
      //   let idFile = fileCongViec.data.fileId;
      //   // Call your delete API here
      //   axios.post(`${process.env.VUE_APP_API_URL}filesminio/delete/${idFile}`).then((response) => {
      //     let resultData = this.modelContent.files.filter((x) => {
      //       return x.fileId != idFile;
      //     });
      //     this.modelContent.files = resultData;
      //     console.log('log model file remove', this.modelContent.files);
      //   }).catch((error) => {
      //     // Handle error here
      //     console.error('Error deleting file:', error);
      //   });
      // }
    },
    sendingEvent(files, xhr, formData) {
      // console.log('log file', files)
      formData.append("files", files);
    },
    formatDate(dateString) {
      // Chuyển đổi định dạng ngày từ DD/MM/YYYY sang YYYY-MM-dd
      const [day, month, year] = dateString.split('/');
      const formattedDate = `${year}-${month}-${day}`;
      return formattedDate;
    },
    async upload() {
      if (this.modelContent != null && this.modelContent.fileImage != null)
      {
        // console.log("LOG this.modelContent : ", this.modelContent)
        axios.post(`${process.env.VUE_APP_API_URL}filesminio/delete/${this.modelContent.fileImage.fileId}`).then((response) => {
          this.modelContent.files = null;
          // console.log('log model file remove', this.modelContent.files);
        }).catch((error) => {
          // Handle error here
          console.error('Error deleting file:', error);
        });
      }

      if ( event.target &&  event.target.files.length > 0 ) {
        const formData = new FormData()
        formData.append('files', event.target.files[0])
        axios.post(`${process.env.VUE_APP_API_URL}filesminio/UploadFileImage`,formData).then((response) => {
          // console.log("LOG UPDATE : ", response);
          let resultData = response.data
          if (response.data.code == 0){
            this.modelContent.fileImage={
              fileId: resultData.data.fileId,
              fileName: resultData.data.fileName,
              ext: resultData.data.ext,
              path: resultData.data.path
            };
            // console.log("LOG UPDATE : ", this.modelContent);
          }
        }).catch((error) => {
          // Handle error here
          console.error('Error deleting file:', error);
        });

      }
    },

    getColorWithExtFile(ext) {
      if (ext == '.docx' || ext == '.doc')
        return 'icon-word';
      else if (ext == '.xlsx' || ext == '.xls')
        return 'icon-excel';
      else if (ext == '.pdf')
        return 'icon-pdf';
      else if (ext == '.png' || ext == '.jpg'|| ext == '.jpeg' )
        return 'text-danger';
      else return 'text-danger';
    },

    getIconWithExtFile(ext) {
      if (ext == '.docx' || ext == '.doc')
        return 'mdi mdi-microsoft-word';
      else if (ext == '.xlsx' || ext == '.xls')
        return 'mdi mdi-microsoft-excel';
      else if (ext == '.pdf')
        return 'mdi mdi-file-pdf-outline';
      else if (ext == '.pptx')
        return 'fas fa-file-powerpoint';
      else if (ext == '.png' || ext == '.jpg'|| ext == '.jpeg')
        return 'mdi mdi-file-image-outline';
      else return 'mdi-file-clock-outline';
    },
    deleteImage(){
      if (this.modelContent != null && this.modelContent.fileImage != null)
      {
        // console.log("LOG this.modelContent : ", this.modelContent)
        axios.post(`${process.env.VUE_APP_API_URL}filesminio/delete/${this.modelContent.fileImage.fileId}`).then((response) => {
          this.modelContent.fileImage = null;
          // console.log('log model file remove', this.modelContent.files);
        }).catch((error) => {
          // Handle error here
          console.error('Error deleting file:', error);
        });
      }
    },
    deleteFile(id) {
      let resultData = this.modelContent.files.filter(x => {
        return x.fileId !=id;
      })
      this.modelContent.files = resultData;
      // console.log('log model file remove', this.modelContent.files)
      axios.post(`${process.env.VUE_APP_API_URL}filesminio/delete/`+id).then((response) => {
        // console.log('log model file remove', this.modelContent.files);
      }).catch((error) => {
        // Handle error here
        console.error('Error deleting file:', error);
      });
    },
  },
  watch: {
    model: {
      deep: true,
      handler(val){
      }
    },

    modelContent: {
      deep: true,
      handler(val){
      }
    },
    $route(to, from) {
      this.baiviet = this.$route.params._id;
      //this.$refs.tblList.refresh();
      //  console.log("LOG CREATED LIEN HE ",this.$route.path)
    },


    // showDeleteModal(val) {
    //   if (val == false) {
    //     this.model.id = null;
    //   }
    // },
    // showPhatHanhModal (val)
    // {
    //     this.isSend = true;
    // },

  },

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="card">
      <div class="card-body">
        <form @submit.prevent="handleSubmit"
              ref="formContainer">
          <div class="row" ref="formContainer">
            <div class="content-lis col-md-6">
              <div class="cs-title-box">
                <div class="cs-title py-2">
                  <span class="fw-normal font-size-13">THÔNG TIN BÀI VIẾT</span>
                </div>
              </div>
            </div>

            <div class="text-end mt-2 col-md-6">
              <b-button type="submit" variant="success" class="ms-1 px-3 btn-luu"
              >Lưu
              </b-button>
            </div>
            <div class="col-12">
              <div class="mb-2">
                <label class="text-left mb-0">Chuyên mục tin</label>
                <span style="color: red">&nbsp;*</span>
                <treeselect
                    v-model="modelContent.menu"
                    v-on:select="AddTree"
                    v-on:deselect="RemoveTree"
                    :normalizer="normalizer"
                    :options="treeView"
                    :searchable="true"
                    :multiple="true"
                    :flat="true"
                    value-format="object"
                    placeholder="Chọn chuyên mục tin"
                    :class="{'is-invalid':submitted && $v.modelContent.menu.$error,}"
                >
                  <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName">
                    {{ node.label }}
                    <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                  </label>
                </treeselect>
                <div
                    v-if="submitted && !$v.modelContent.menu.required"
                    class="invalid-feedback"
                >
                  Chuyên mục tin không được trống.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-2">
                <label class="text-left mb-0">Tiêu đề bài viết</label>
                <span style="color: red">&nbsp;*</span>
                <input
                    v-model="modelContent.name"
                    id="percent"
                    type="text"
                    class="form-control"
                />
                <!-- <div
                    v-if="submitted && !$v.modelContent.name.required"
                    class="invalid-feedback"
                >
                  Tiêu đề không được trống.
                </div> -->
              </div>
            </div>
            <div class="col-12">
              <div class="form-check form-switch mb-2">
                <label class="text-left mb-2">Xuất bản</label>
                <input
                    v-model="modelContent.isPublic"
                    class="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckChecked"
                    checked=""
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-2 ">
                <label class="text-left mb-0">Mô tả</label>
                <input
                    v-model="modelContent.moTa"
                    id="percent"
                    type="text"
                    class="form-control"
                    placeholder="Nhập mô tả"
                />
              </div>
            </div>
            <div class="col-3">
              <div class="mb-2 ">
                <label class="text-left mb-0">Ngày xuất bản</label>
                <date-picker v-model="modelContent.ngayXuatBan"
                             format="DD/MM/YYYY HH:mm"
                             id="percent"
                             placeholder="Nhập ngày xuất bản"
                >
                </date-picker>
              </div>
            </div>
            <div class="col-3">
              <div class="mb-2 ">
                <label for="formFileSm" class="text-left mb-0">Ảnh đại diện</label>
                <input
                    id="formFileSm"
                    name="file-input"
                    ref="fileInput"
                    type="file"
                    class="form-control"
                    @change="upload($event)"

                />
              </div>
              <template  v-if="modelContent.fileImage" >
                <a
                    class="ml-25"
                    :href="`${urlFile}/${modelContent.fileImage.fileId}`"
                ><i
                    :class="`${getColorWithExtFile(modelContent.fileImage.ext)} me-2 ${getIconWithExtFile(modelContent.fileImage.ext)}`"
                ></i>{{modelContent.fileImage.fileName }}</a>
                <b-button
                    variant="flat-danger"
                    class="btn-icon"
                    @click="deleteImage()"
                >
                  <i class="mdi mdi-trash-can-outline"></i>
                </b-button>

              </template>
            </div>
            <div class="col-4">
              <div class="mb-2 ">
                <label class="text-left mb-0">Trích yếu</label>
                <input
                    v-model="modelContent.trichYeu"
                    id="percent"
                    type="text"
                    class="form-control"
                    placeholder="Nhập trích yếu"
                />
              </div>

            </div>
            <div class="col-4">
              <div class="mb-2 ">
                <label class="text-left mb-0">Số ký hiệu</label>
                <input
                    v-model="modelContent.soKiHieu"
                    id="percent"
                    type="text"
                    class="form-control"
                />
              </div>

            </div>
            <div class="col-4">
              <div class="mb-2 ">
                <label class="text-left mb-0">Ngày ký</label>
                <date-picker v-model="modelContent.ngayKy"
                             format="DD/MM/YYYY"
                             id="percent"
                             placeholder="Nhập ngày ký"
                >
                </date-picker>
              </div>
            </div>

            <div class="content-lis col-10">
              <div class="cs-title-box">
                <div class="cs-title py-2">
                  <span class="fw-normal font-size-13">NỘI DUNG BÀI VIẾT</span>
                </div>
              </div>
            </div>
            <div>
              <!--              <ckeditor v-model="modelContent.noiDung"-->
              <!--                             :config="editorConfig"/>-->
              <ckeditor-nuxt v-model="modelContent.noiDung"
                             :config="editorConfig">

              </ckeditor-nuxt>
              <div
                  v-if="submitted && !$v.modelContent.noiDung.required"
                  class="invalid-feedback"
              >
                Nội dung bài viết không được trống.
              </div>
            </div>
            <template  v-if="modelContent.files.length > 0" >
              <div v-for="(file,index) in modelContent.files" :key="index">
                <a
                    class="ml-25"
                    :href="`${urlFile}/${file.fileId}`"
                ><i
                    :class="`${getColorWithExtFile(file.ext)} me-2 ${getIconWithExtFile(file.ext)}`"
                ></i>{{ file.fileName }}</a>
                <b-button
                    variant="flat-danger"
                    class="btn-icon"
                    @click="deleteFile(file.fileId)"
                >
                  <i class="mdi mdi-trash-can-outline"></i>
                </b-button>
              </div>
            </template>
            <template>
              <div style="margin-top: 20px;">
                <vue-dropzone
                    id="dropzone"
                    ref="myVueDropzone"
                    :use-custom-slot="true"
                    :options="dropzoneOptions"
                    v-on:vdropzone-sending="sendingEvent"
                    v-on:vdropzone-removed-file="removeThisFile"
                    v-on:vdropzone-success="uploadFile"
                >
                  <div class="dropzone-custom-content">
                    <div class="mb-1">
                      <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                    </div>
                    <h4>Kéo thả tệp hoặc click vào đây để tải tệp tin.</h4>
                  </div>
                </vue-dropzone>
              </div>
            </template>

          </div>
        </form>

        <!-- <div class="row">
          <div class="col-md-12 text-center" >
            <b-button
                class="btn cs-btn-primary btn-rounded mb-2 me-2"
                variant="success"
                v-on:click="handleSubmit"
            >
              <i class="bx bx-save "></i>
              Lưu
            </b-button>
          </div>
        </div> -->

      </div>
    </div>

  </Layout>
</template>
<style>

.hidden-sortable:after, .hidden-sortable:before {
  display: none !important;
}
.vue-treeselect__menu{
  max-height: 165px !important;
}
.btn-luu{
  background-color: #05912a;
  border: none;
}
.btn-luu:hover{
  background-color: #05912a;

}
.mx-table .mx-table-date .table thead th, thead, th {
  background-color: rgb(255, 255, 255)!important;
  accent-color: #0e0e0e !important;
  border: none;
}
.mx-calendar-content .cell.active {
  color: #fff;
  background-color: #1284e7 !important;
}

</style>

